import React from 'react';

import { Box, Card, Divider, Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const SideMenuCard = ({ children, icon, title }) => (
    <Card
        sx={{
            backgroundColor: 'transparent !important',
            border: '1px solid rgba(233, 236, 245, 1)',
            boxShadow: 'none !important',
            mb: '16px !important',
        }}
    >
        <Box
            sx={{ alignItems: 'center', display: 'flex', gap: 1, px: 2, py: 1 }}
        >
            {icon}
            <Typography fontWeight="bold" variant="body2">
                {title}
            </Typography>
        </Box>
        <Divider />
        <Box sx={{ px: 2, py: 1 }}>{children}</Box>
    </Card>
);

SideMenuCard.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    icon: PropTypes.object,
    title: PropTypes.string,
};

export default SideMenuCard;
